<template>
	<div v-if="isMobile" :style="footerStyle">
		<nav class="navbar fixed-bottom checkout-bar checkout-footer">
			<button
				v-if="showCheckoutButton"
				class="button button-primary checkout-btn"
				@click="footerButtonClicked"
				:disabled="checkoutDisabled"
				data-cy="footer-mobile-checkout-button"
			>
				<span>
					{{ itemsInCartCount }}
				</span>
				<span>
					{{ buttonText }}
				</span>
				<span>
					{{ cartTotal | currency }}
				</span>
			</button>
			<div class="terms-of-use-and-policy-section" v-if="isCheckout">
				<span>
					By placing your order, you agree to be charged and to our
					<a class="url" :href="tosUrl" target="_blank">
						Terms of Use
					</a>
					and
					<a class="url" :href="privacyUrl" target="_blank">
						Privacy Policy.
					</a>
				</span>
			</div>
			<MenuDeliveryBar v-if="showDeliveryBar" class="menu-delivery-bar" />
		</nav>
	</div>
</template>

<style scoped>
.terms-of-use-and-policy-section {
	padding: 0 10px;
	font-size: 11px;
	color: var(--sk-grey3);
	text-align: center;
	width: 100%;
}

.url {
	color: var(--gR-teal-60);
}

.checkout-footer {
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>

<script>
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import checkoutValidationMixin from "@/mixins/checkout-validation-mixin"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import MenuDeliveryBar from "@/components/menu/MenuDeliveryBar.vue"

export default {
	name: "Footer",
	components: {
		MenuDeliveryBar
	},
	mixins: [
		currencyFilterMixin,
		checkoutValidationMixin,
		mobileResponsivenessMixin
	],
	props: {
		showDeliveryBar: Boolean
	},
	data: function () {
		return {
			mobileThresholdWidth: 900
		}
	},
	computed: {
		itemsInCartCount() {
			return this.$store.getters.itemsInCartCount
		},
		slug() {
			return this.$route.params.slug
		},
		business() {
			return this.$store.state.business
		},
		checkoutDisabled() {
			return this.$store.state.business.is_active == 0
		},
		buttonText() {
			return this.$route.meta.isCheckout == true
				? "Place Order"
				: "View Cart"
		},
		showCheckoutButton() {
			return this.itemsInCartCount > 0
		},
		footerStyle() {
			let height = 0
			if (this.showCheckoutButton) {
				height += 50
			}
			if (this.showDeliveryBar) {
				height += 55
			}
			return {
				height: `${height}px`
			}
		},
		tosUrl() {
			return "/" + this.$route.params.slug + "/terms_of_use"
		},
		privacyUrl() {
			return "/" + this.$route.params.slug + "/privacy"
		},
		isCheckout() {
			return window.location.href.indexOf("checkout") > -1
		}
	},
	methods: {
		footerButtonClicked() {
			if (this.$route.meta.isCheckout === true) {
				this.$emit("checkout")
			} else {
				this.openCartSummary()
			}
		},
		logIfAppMinimumNotMet() {
			if (this.cartMinimumNotMet() && !this.isResidential) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "App Minimum Alert"
				})
			}
		},
		openCartSummary() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Click Cart"
			})

			this.validateCart()
				.then(() => {
					this.$emit("openCartSummary")
				})
				.catch(() => {})
		}
	}
}
</script>